<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<br/><br/><br/><br/><br/><br/><br/><br/><br/>
<p style="text-align: center;">Also by Cat Walker</p><br/>
<p style="text-align: center;"><em>Irish Fireworks</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1e816835